module.exports = __webpack_public_path__ + "img/tm_s.1c6c2dd8.png";